export default __webpack_public_path__ + "static/media/user-redflag.7bcb4c7e.svg";